var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",class:[_vm.skinClasses],attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.name})],1),_c('confirm-modal'),_c('photo-archive-picker-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }